import { AppRouteProps } from "@harea/component";
import { ImportContainer } from "./container/ImportContainer";

export const DataImportRoutes: Array<AppRouteProps> = [
    {
        title: "Harea.Data.Import.Title",
        path: "import",
        element: <ImportContainer />,
    },
];
